/**
 * Color-coded status indicator dot
 * Story 198: View and filter stories in backlog
 */

import './StatusDot.css';

/** Status color mapping - exported for test synchronization */
export const STATUS_COLORS: Record<string, string> = {
  proposed: '#6e7681',
  'in-progress': '#f0883e',
  qa: '#58a6ff',  // Story 274
  blocked: '#f85149',
  paused: '#a371f7',
  done: '#3fb950',
};

interface StatusDotProps {
  status: string;
}

export function StatusDot({ status }: StatusDotProps) {
  const color = STATUS_COLORS[status] ?? STATUS_COLORS.proposed;

  return (
    <span
      className="status-dot"
      style={{ backgroundColor: color }}
      title={status}
    />
  );
}
